import React, { FC } from 'react';

import { useAppSelector } from '@hooks/shared/reduxHooks';
import { useResponsive } from '@hooks/shared/useResponsive';
import { Container } from '@styled/shared/Container';
import { mobileTableRender } from '@utils/shared/table/mobileTableRenderer';
import { Table, Typography } from 'antd';
import { t } from 'i18next';

const { Text } = Typography;

interface ISupportManagersProps {
	showBlockTitle?: boolean;
}

const SupportManagers: FC<ISupportManagersProps> = ({ showBlockTitle = true }) => {
	const client = useAppSelector((state) => state.user.client);
	const { mobileOnly, isTablet, isSmallDesktop } = useResponsive();
	const showMobileLayout = mobileOnly || (isTablet && !isSmallDesktop);

	const managers = client?.managers.map((item, index) => ({ ...item, key: index })) || [];
	const columns = [
		{
			title: 'name',
			dataIndex: 'manager',
			width: '100%',
			key: 'name',
		},
		{
			title: 'phone',
			dataIndex: 'phone',
			key: 'phone',
			width: 100,
			render: (v: string) => (
				<a style={{ textDecoration: 'underline', color: 'var(--green)' }} href={`tel:${v}`}>
					{t(v)}
				</a>
			),
		},
		{
			title: 'email',
			dataIndex: 'email',
			key: 'email',
			width: '150px',
			render: (v: string) => (
				<a style={{ textDecoration: 'underline', color: 'var(--green)' }} href={`mailto:${v}`}>
					{t(v)}
				</a>
			),
		},
	];

	return (
		<Container
			className='content-wrapper'
			vertical
			gap={8}
			style={{ maxWidth: showMobileLayout ? '100%' : '50%' }}>
			{showBlockTitle && (
				<Text type='secondary' className='block-title'>
					{t('aboutCompany.managers')}
				</Text>
			)}
			<Table
				bordered={true}
				dataSource={managers}
				columns={showMobileLayout ? columns.slice(0, 1) : columns}
				showHeader={false}
				pagination={false}
				expandable={
					showMobileLayout
						? {
								expandedRowRender: (row) =>
									columns.slice(1).map((item, index) => {
										// console.log({ item });
										return mobileTableRender(item, row);
									}),
								expandRowByClick: true,
								indentSize: 15,
							}
						: undefined
				}
			/>
		</Container>
	);
};

export default SupportManagers;
